// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"99b688b7","578":"de3f0d58","879":"e3ea51ec"}[chunkId] + ".chunk.js";
};